import { currentUnit, isUnitLoading, setUnitSetting, Unit } from '@features/settings/reducer';
import { Dispatch } from '@reduxjs/toolkit';
import { RadioButton } from '@rio-cloud/rio-uikit';
import { trackingAttributes } from '@utils/tracking';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { LangStatePart, SettingStatePart } from '../../../setup/types';

export const UnitFormat: React.FC<{
    currentUnit: Unit;
    isLoading: boolean;
    setCurrentUnit: (unit: Unit) => void;
}> = ({ currentUnit, isLoading, setCurrentUnit }) => {
    return (
        <div className="panel panel-default" data-test="calculationParameters">
            <div className="panel-body">
                <div
                    style={{ height: '64px' }}
                    className="row align-items-center display-block-xs display-flex-md padding-top-15 padding-bottom-15"
                >
                    <div className="text-size-16 col-md-3 col-xs-12 display-flex align-items-center text-medium">
                        <FormattedMessage id="administration.unit.display" />
                    </div>
                    <div className="col-md-6 col-xs-12">
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '2px',
                            }}
                        >
                            <div className="text-medium text-color-gray">
                                <FormattedMessage id="administration.unit.description.title" />
                            </div>

                            <div style={{ whiteSpace: 'normal' }} className="text-color-gray">
                                <FormattedMessage id="administration.unit.description.body" />
                            </div>
                        </div>
                    </div>

                    <div
                        style={{ paddingRight: '100px' }}
                        className="gap-20 col-md-4 text-right col-xs-12 display-flex align-items-center justify-content-end"
                    >
                        <RadioButton
                            {...trackingAttributes(
                                'click',
                                'perform, administrationPage',
                                'imperialUnit',
                                'administration'
                            )}
                            name="radioButtonImperial"
                            onChange={() => setCurrentUnit(Unit.imperial)}
                            checked={currentUnit === Unit.imperial}
                            disabled={isLoading}
                            inline
                        >
                            <FormattedMessage id="administration.unit.imperial" />
                        </RadioButton>

                        <RadioButton
                            {...trackingAttributes(
                                'click',
                                'perform, administrationPage',
                                'metricUnit',
                                'administration'
                            )}
                            name="radioButtonMetric"
                            onChange={() => setCurrentUnit(Unit.metric)}
                            checked={currentUnit === Unit.metric}
                            disabled={isLoading}
                            inline
                        >
                            <FormattedMessage id="administration.unit.metric" />
                        </RadioButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const mapStateToProps = (state: SettingStatePart & LangStatePart) => ({
    currentUnit: currentUnit(state),
    isLoading: isUnitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setCurrentUnit: (unit: Unit) => dispatch(setUnitSetting(unit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnitFormat);
